module.exports = __webpack_public_path__ + "img/logo-white-background.8a9a866e.svg";